<b-modal v-model="modal_requirement_094" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      <template v-if="phase === 'standby'">
        {{ $t('message.common_title_confirmation') }}
      </template>
      <template v-if="phase === 'success'">
        {{ $t('message.common_title_success') }}
      </template>
      <template v-if="phase === 'executeFailed' || phase === 'failed'">
        {{ $t('message.common_title_error') }}
      </template>
    </div>
  </template>

  <template v-slot:default>
    <ShowLessBOverlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!--開始確認-->
        <template v-if="phase === 'standby'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <div class="box-margin-right work-support-message">{{ $t(`${i18nWsKey}.REQ_WS_94_TXT_1`) }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 停止 -->
        <template v-if="phase === 'success'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <div class="box-margin-right work-support-message">{{ $t(`${i18nWsKey}.REQ_WS_94_TXT_2_0002`) }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 異常終了(固有エラー) -->
        <template v-if="phase === 'executeFailed'">
          <div class="w-100">
            <div class="box-margin-right work-support-message">{{ $t(`${i18nWsKey}.REQ_WS_94_TXT_3`) }}</div>
          </div>
        </template>
        <!-- 異常終了(共通エラー) -->
        <template v-if="phase === 'failed'">
          <div class="w-100">
            <div class="box-margin-right work-support-message" v-html="$t(`individual.error_communication_error`)">
            </div>
          </div>
        </template>
      </div>
    </ShowLessBOverlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <!-- 開始確認 -->
      <template v-if="phase === 'standby'">
        <b-button size="sm" variant="outline-primary" :disabled="isLoading" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" variant="primary" :disabled="isLoading" @click="standbyProcess" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 固有エラー -->
      <template v-if="phase === 'executeFailed'">
        <b-button size="sm" variant="outline-primary" :disabled="isLoading" @click="exitProcess" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" variant="primary" :disabled="isLoading" @click="executeProcess" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 停止 / 共通エラー -->
      <template v-if="phase === 'success' || phase === 'failed'">
        <b-button size="sm" variant="primary" :disabled="isLoading" @click="exitProcess" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>